import {Utilities} from '../utilities/utilities.model';

export abstract class ListModel<T = any> {
	stats: Navigation;
	items: T[];

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.stats = new Navigation(model.stats);
		}
	}
}

export class Navigation {
	itemsCount: number;
	pagesCount: number;
	currentPage: number;
	pageSize: number;
	itemsCountByStatus: ItemsCountByStatus;
	surveyorItemsCountByType: SurveyorItemsCountByType;

	constructor(model?: any) {
		if (model) {
			if (model.itemsCount) {
				this.itemsCount = model.itemsCount;
			}
			if (model.items_count) {
				this.itemsCount = model.items_count;
			}
			if (model.item_count) {
				this.itemsCount = model.item_count;
			}

			if (model.pagesCount) {
				this.pagesCount = model.itemsCount;
			}
			if (model.page_count) {
				this.pagesCount = model.page_count;
			}

			if (model.currentPage) {
				this.currentPage = model.currentPage;
			}
			if (model.current_page) {
				this.currentPage = model.current_page;
			}

			if (model.pageSize) {
				this.pageSize = model.pageSize;
			}
			if (model.page_size) {
				this.pageSize = model.page_size;
			}

			this.itemsCountByStatus = new ItemsCountByStatus(model.itemsCountByStatus);
			this.surveyorItemsCountByType = new SurveyorItemsCountByType(model.surveyorItemsCountByType);

		}
	}
}

export class ItemsCountByStatus {
	pending: number;
	planned: number;
	planning: number;
	total: number;

	constructor(model?: any) {
		if (model) {
			this.pending = model.pending;
			this.planned = model.planned;
			this.planning = model.planning;
			this.total = model.total;
		}
	}
}

export class SurveyorItemsCountByType {
	dedicated: number;
	not_dedicated: number;

	constructor(model?: any) {
		if (model) {
			this.dedicated = model.dedicated;
			this.not_dedicated = model.not_dedicated;
		}
	}
}
